<template>
    <div class="loading flex flex-align flex-center" v-if="loading">
        <spinner />
    </div>
    <form class="assign" :theme="theme" @submit.prevent="assign" v-else>
        <label>Assign To</label>
        <div class="flex flex-align">
            <select type="text" v-model="assignment.course" class="medium">
                <option v-if="courses.length" v-for="course of courses" :value="course">{{course.title}}</option>
                <option v-else disabled>No Courses Available</option>
            </select>
            <checkbox class="inactive-courses" label="Hide Inactive Courses" :checked="active" />
        </div>
        <label>Title</label>
        <input type="text" v-model="assignment.title" class="large" />
        <label>Instructions (Optional)</label>
        <textarea v-model="assignment.description"></textarea>
        <label>Due Date</label>
        <div class="flex flex-align">
            <datetime-picker v-model="assignment.due_date" id="assignment-due-date" no-label no-button-now no-clear-button output-format="YYYY-MM-DDTHH:mm:ssZ" format="YYYY-MM-DDTHH:mm:ssZ" />
            <a class="text-button display-date-button" v-if="!assignment.display_date" @click="add_display_date">Set Display Date</a>
        </div>
        <template v-if="assignment.display_date">
            <label>Display Date</label>
            <datetime-picker v-model="assignment.display_date" id="assignment-due-date" no-label no-button-now no-clear-button output-format="YYYY-MM-DDTHH:mm:ssZ" format="YYYY-MM-DDTHH:mm:ssZ" />
        </template>
        <template v-if="terms.length">
            <label>Grading Period</label>
            <div class="flex flex-align">
                <select type="text" v-model="assignment.grading_period" class="medium">
                    <option v-for="term of terms" :value="term.id">{{term.name}}</option>
                </select>
                <checkbox class="inactive-courses" label="Hide Inactive Courses" :checked="active" />
            </div>
        </template>
        <div class="flex flex-align assign-options">
            <button type="submit">Assign Exercise</button>
            <div class="or">or</div>
            <div class="text-button" @click="$emit('close')">Cancel</div>
        </div>
    </form>
</template>

<script>
    export default {
        name: 'Assign',
        props: {
            resource: Object
        },
        data(){
            return {
                loading: false,
                active: true,
                students: [],
                terms: [],
                assignment: {
                    title: '',
                    description: 'Please complete the following assignment.',
                    due_date: new Date().toISOString(),
                    display_date: null,
                    lock_date: null,
                    personalized: false,
                    students: [],
                    course: {
                        id: null,
                        serviceId: null
                    },
                    resource: null
                }
            };
        },
        computed: {
            theme(){
                return this.$store.state.theme.active;
            },
            courses(){
                return this.$store.state.courses.all;
            },
            product(){
                return this.$store.getters.product;
            }
        },
        methods: {
            assign(){
                if(this.loading){
                    return;
                }

                this.assignment.due_date = new Date(this.assignment.due_date).toISOString();
                this.assignment.display_date = this.assignment.display_date ? new Date(this.assignment.display_date).toISOString() : null;
                this.assignment.lock_date = this.assignment.lock_date ? new Date(this.assignment.lock_date).toISOString() : null;

                const display = new Date(this.assignment.display_date);
                const due = new Date(this.assignment.due_date);
                const lock = new Date(this.assignment.lock_date);

                if(this.assignment.display_date && display < new Date()){
                    return this.$toasted.error('The display date must be in the future.');
                }

                if(this.assignment.due_date && due < new Date()){
                    return this.$toasted.error('The due date must be in the future.');
                }

                if(this.assignment.lock_date && lock < new Date()){
                    return this.$toasted.error('The lock date must be in the future.');
                }

                //We need to verify a couple of constraints here. Basically, display date < due date < lock date.

                if(this.assignment.due_date && this.assignment.display_date && due < display){
                    return this.$toasted.error('The due date must be at or after the display date.');
                }

                if(this.assignment.due_date && this.assignment.lock_date && due > lock){
                    return this.$toasted.error('The lock date must be at or after the due date.');
                }

                this.loading = true;

                this.$http.post(`/assignments`, this.assignment)
                .then(() => {
                    this.$toasted.success(`Assigned successfully.`);
                    this.$emit('close');
                })
                .catch(error => this.$toasted.error('There was an error creating your assignment.'))
                .finally(() => this.loading = false);
            },
            add_display_date(){
                this.assignment.display_date = new Date().toISOString();
            }
        },
        created(){
            this.assignment.resource = this.resource;
            this.assignment.title = this.resource.title;
            this.loading = false;

            if(this.courses.length){
                this.assignment.course = this.courses.slice().shift();
            }
        }
    }
</script>

<style scoped lang="less">
    @import "~@/assets/less/variables";

    .loading
    {
        background: @white;
        border-radius: 3px;
        height: 200px;
    }

    .assign
    {
        background: var(--modal-background-color);
        border-radius: 3px;

        h4
        {
            font-weight: 500;
            padding: 10px;
            font-size: 14px;
            color: @grey;
        }

        .date-time-picker
        {
            max-width: 325px;
            margin: 0;
        }

        label.inactive-courses.checkbox
        {
            border: 0;
            margin-left: 10px;

            .checkbox-label
            {
                font-size: 13px;
                color: @grey;
            }
        }
    }

    form
    {
        padding: 20px;
    }

    label
    {
        margin-top: 20px;

        &:first-child
        {
            margin-top: 0;
        }
    }

    textarea
    {
        min-height: 120px;
    }

    .assign-options
    {
        margin-top: 20px;
    }

    .or
    {
        margin: 0 15px;
        font-size: 14px;
        height: 16px;
        line-height: 16px;
    }

    .display-date-button
    {
        margin-left: 20px;
    }
</style>
